import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=1535361e&"
import script from "./Household.vue?vue&type=script&lang=ts&"
export * from "./Household.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports